import React, { useContext } from 'react';
import projectContext from '../../context/projects/projectContext';
import taskContext from '../../context/tasks/taskContext';

const Task = ({ task }) => {

    // Get info for project context
    const projectsContext = useContext(projectContext);
    const { project } = projectsContext;

    // Get the actual project
    const [ actualProject ] = project;

    // Get the info for task context
    const tasksContext = useContext(taskContext);
    const { deleteTask, getTasks, /*changeStatusTask,*/ updateTask, setActualTask } = tasksContext;

    //Function to execute the action to delete a task
    const taskToDelete = id => {
        deleteTask(id, actualProject._id);
        getTasks(actualProject.id);
    }

    // Function to change the status of a task
    const changeStatus = task => {
        if(task.status){
            task.status = false;
        } else {
            task.status = true;
        }
        //changeStatusTask(task);
        updateTask(task);
    }

    // Function to select a Task
    const selectTask = task => {
        setActualTask(task);
    }

    return (
        <li className="tarea sombra">
            <p>{ task.name }</p>
            <div className="estado">
                {
                    task.status
                    ?
                    (
                        <button
                            type="button"
                            className="completo"
                            onClick={ () => changeStatus(task) }
                        >
                            Completed
                        </button>
                    )
                    :
                    (
                        <button
                            type="button"
                            className="incompleto"
                            onClick={ () => changeStatus(task) }
                        >
                            Incompleted
                        </button>
                    )
                }
            </div>
            <div className="acciones">
                <button
                    type="button"
                    className="btn btn-primario"
                    onClick={ () => selectTask(task) }
                >
                    Edit
                </button>
                <button
                    type="button"
                    className="btn btn-secundario"
                    onClick={ () => taskToDelete(task._id) }
                >
                    Delete
                </button>
            </div>
        </li>
    );
}
 
export default Task;